import PropTypes from 'prop-types';
import { Layout } from '../../common/components';
import DurationFilters from './DurationFilters';
import NewCommonFilters from './newCommonFilters';

function IndividualDashboardLayout({
  durationType,
  children,
  dateChangeHandler,
  searchHandler,
  className,
}) {
  return (
    <Layout className="dashboard-main-layout">
      <div className="dashboard-layout-wrapper">
        <NewCommonFilters />
        <DurationFilters
          type={durationType}
          dateChangeHandler={dateChangeHandler}
          searchHandler={searchHandler}
        />
        <div className={`dashboard-body ${className}`}>{children}</div>
      </div>
    </Layout>
  );
}

IndividualDashboardLayout.propTypes = {
  durationType: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  dateChangeHandler: PropTypes.func.isRequired,
  searchHandler: PropTypes.func.isRequired,
  className: PropTypes.string,
};

IndividualDashboardLayout.defaultProps = {
  className: '',
};

export default IndividualDashboardLayout;
